"use strict";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var $BigInt = typeof BigInt !== "undefined" && BigInt;
module.exports = function hasNativeBigInts() {
    return typeof $BigInt === "function" && typeof BigInt === "function" && _type_of($BigInt(42)) === "bigint" // eslint-disable-line no-magic-numbers
     && _type_of(BigInt(42)) === "bigint"; // eslint-disable-line no-magic-numbers
};
